import Layout from './Layout';

const AgentConsole: React.FC = () => <Layout />;

export default AgentConsole;
